import { $applyNodeReplacement, TextNode } from 'lexical'

export class FilterNode extends TextNode {
  static getType() {
    return 'filter'
  }

  static clone(node) {
    // eslint-disable-next-line no-underscore-dangle
    return new FilterNode(node.__text, node.__key)
  }

  // eslint-disable-next-line no-useless-constructor
  constructor(text, key) {
    super(text, key)
  }

  createDOM(config) {
    const element = super.createDOM(config)
    element.classList.add(config.theme.filter)
    return element
  }

  static importJSON(serializedNode) {
    const node = $createFilterNode(serializedNode.text)
    node.setFormat(serializedNode.format)
    node.setDetail(serializedNode.detail)
    node.setMode(serializedNode.mode)
    node.setStyle(serializedNode.style)
    return node
  }

  exportJSON() {
    return {
      ...super.exportJSON(),
      type: 'filter',
    }
  }

  canInsertTextBefore() {
    return true
  }

  isTextEntity() {
    return true
  }
}

export function $createFilterNode(text = '') {
  return $applyNodeReplacement(new FilterNode(text))
}

export function $isFilterNode(node) {
  return node instanceof FilterNode
}
